import React, { useState } from 'react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito tener conocimientos previos de espiritualidad o sanación?',
    a: 'No. Este método está diseñado para acompañarte desde cero. Si es tu primera vez trabajando con rituales o psicogenealogía, el producto te lleva de la mano paso a paso.'
  }, {
    q: '¿Qué pasa si no tengo datos de mi linaje o no conocí a mis abuelas?',
    a: 'No necesitás nombres ni fechas exactas. La energía del linaje fluye en tu ADN independientemente de si tenés datos concretos. Podés trabajar con "Abuela materna" o "Bisabuela" y el proceso funciona igual.'
  }, {
    q: '¿Cuánto tiempo necesito por día para hacer el proceso?',
    a: 'Con 15 a 20 minutos diarios es suficiente. Los rituales y meditaciones están diseñados para adaptarse a tu vida cotidiana, no para exigirte horas extra.'
  }, {
    q: '¿Este producto reemplaza la terapia psicológica?',
    a: 'No. Este es un método complementario de sanación holística. Si estás en terapia, este material puede potenciar enormemente tu proceso. Si tenés una condición de salud mental diagnosticada, consultá con tu profesional antes de comenzar.'
  }, {
    q: '¿En qué formato recibo el producto?',
    a: 'Todo es digital. Recibirás PDFs de alta calidad que podés leer en tu celular, tablet o computadora. Acceso inmediato tras la compra.'
  }, {
    q: '¿Qué pasa si siento que no es para mí?',
    a: 'Tenés 7 días de garantía total. Si no sentiste ningún movimiento interno después de leer el primer capítulo y hacer el primer ritual, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  return <section className="py-8 px-4 bg-cream" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-42">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-6" data-id="element-43">
          {faqs.map((faq, idx) => <details key={idx} className="group bg-white rounded-2xl shadow-sm border border-soft-rose overflow-hidden" data-id="element-44">
              <summary className="flex items-center justify-between cursor-pointer p-6 font-semibold text-lg text-warm-brown-dark" data-id="element-45">
                <span className="flex gap-2" data-id="element-46">
                  <span className="text-deep-rose" data-id="element-47">❓</span>
                  {faq.q}
                </span>
                <span className="transition group-open:rotate-180 text-deep-rose" data-id="element-48">
                  <svg fill="none" height="24" shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24" data-id="element-49">
                    <path d="M6 9l6 6 6-6" data-id="element-50"></path>
                  </svg>
                </span>
              </summary>
              <div className="px-4 pb-4 pt-2 text-warm-brown leading-relaxed pl-10 text-sm" data-id="element-51">
                {faq.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}